<div id="lista" class="page-layout carded fullwidth">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent"
             fxLayout="column" fxLayoutAlign="center center"
             fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center">

            <!-- TÍTULO E BOTÕES ALINHADOS -->
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="nogrow">
                <div class="logo mb-24 mb-md-0"
                     fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon class="logo-icon s-32 mr-16">
                        business
                    </mat-icon>
                    <span class="logo-text h1">
                        Baskets
                    </span>
                </div>

                <!-- BOTÕES ALINHADOS AO LADO DO TÍTULO -->
                <div fxLayout="row" fxLayoutAlign="start center" style="margin-left: 16px; gap: 8px;">
                    <!-- Botão Consultar -->
                    <button mat-mini-fab 
                            color="accent"
                            matTooltip="Consultar"
                            (click)="openFiltro()">
                        <mat-icon>search</mat-icon>
                    </button>
                    
                    <!-- Botão Nova Basket -->
                    <button mat-mini-fab 
                            color="accent"
                            matTooltip="Nova Basket"
                            (click)="openCadastro()">
                        <mat-icon>add_circle</mat-icon>
                    </button>
                </div>
            </div>
            <!-- / TÍTULO E BOTÕES ALINHADOS -->

        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <ngx-datatable 
                #table 
                class='material striped' 
                [loadingIndicator]="false"
                [columns]="columns"
                [columnMode]="'force'" 
                [headerHeight]="50"
                [footerHeight]="50" 
                [rowHeight]="'auto'"
                (sort)="onSort($event)"
                [rowClass]="getRowClass"
                [rows]='rows'>

                <ngx-datatable-column name="Data" prop="created_at" [sortable]="false" [width]="50">
                    <ng-template let-rowIndex="rowIndex" let-created_at="value" ngx-datatable-cell-template>
                        {{created_at | date:'dd/MM/yyyy'}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Tipo" prop="tipo_basket" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-tipo_basket="value" ngx-datatable-cell-template>
                        {{tipo_basket.nome}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Responsavel" prop="users" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-users="value" ngx-datatable-cell-template>
                        {{users.name}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Qtd. Ordens" prop="qtd_ordens" [sortable]="false" [width]="50">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        {{ getTotalOrdens(row) }}
                    </ng-template>
                </ngx-datatable-column>    

                <ngx-datatable-column name="Qtd. Cancel." prop="qtd_ordens_canceladas" [sortable]="false" [width]="50">
                    <ng-template let-rowIndex="rowIndex" let-qtd_ordens_canceladas="value" ngx-datatable-cell-template>
                        <span style='color:red'>{{ qtd_ordens_canceladas }}</span>
                    </ng-template>
                </ngx-datatable-column>
                
                <ngx-datatable-column name="%" prop="percentual" [sortable]="false" [width]="50">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        {{ getPercentual(row) }} %
                    </ng-template>
                </ngx-datatable-column>
                
                <ngx-datatable-column name="Rótulo" prop="nome_arquivo" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-nome_arquivo="value" ngx-datatable-cell-template>
                        {{nome_arquivo}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Ação" prop="id" [sortable]="false" [width]="80">
                    <ng-template let-rowIndex="rowIndex" let-id="value" ngx-datatable-cell-template>
                        <button mat-icon-button matTooltip="Visualizar Basket" (click)="openVisualizar(id)">
                            <mat-icon aria-label="Visualizar Basket">search</mat-icon>
                        </button>

                        <button mat-icon-button color="warn" matTooltip="Excluir Basket" (click)="delete(id)">
                            <mat-icon aria-label="Excluir Basket">delete</mat-icon>
                        </button>

                    </ng-template>
                </ngx-datatable-column>

            </ngx-datatable>

            <div style="padding: 5px 10px">
                <mat-paginator 
                    #paginator 
                    [length]="length"
                    [pageSize]="pageSize"
                    [pageSizeOptions]="pageSizeOptions"
                    (page)="pageEvent($event)">
                </mat-paginator>
            </div>
        </div>
    </div>
</div>